import { combineReducers } from 'redux'
import { loadingBarReducer } from 'react-redux-loading-bar'
import site from './site'
import page from './page'

export default combineReducers({
	loadingBar: loadingBarReducer,
	site: site,
	page: page
})



// WEBPACK FOOTER //
// ./redux/reducers/index.js